import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './TariffAction.module.scss';
import { InfoSquareIcon } from '@icons';
import TariffText from '../TariffText/TariffText';
import Button from '@shared/Button/Button';
import { useWindowSize } from '@hooks/useWindowSize';
import classNames from 'classnames/bind';
const TariffAction = ({ buttonText, onClick, isError, isLoading, hideButton = false }) => {
    const { isMobileSm, isMobile, isTablet } = useWindowSize();
    const containerClasses = classNames(classes.container, {
        [classes.error]: isError,
    });
    const buttonColor = isMobileSm ? 'primary' : 'alwaysSecondary';
    return (_jsxs("div", { className: containerClasses, children: [_jsx(InfoSquareIcon, { containerClasses: classes.icon }), _jsx(TariffText, { className: classes.text }), !hideButton && (_jsx(Button, { variant: buttonColor, size: isMobile || isTablet ? 'sm' : 'md', full: isMobileSm, text: buttonText, onClick: onClick, className: classes.button, isLoading: isLoading }))] }));
};
export default TariffAction;
